import { render, staticRenderFns } from "./JBOffers.vue?vue&type=template&id=443d26e7"
import script from "./JBOffers.vue?vue&type=script&lang=js"
export * from "./JBOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports